import { connectRouter } from 'connected-react-router'
import { combineReducers } from 'redux'
import dashboard from './dashboard/reducers'
import discount from './Discount/reducers'
import food from './food/reducers'
import { foodMenuData } from './foodMenu/reducers'
import menu from './menu/reducers'
import notification from './Notification/Reducers'
import orders from './orders/reducers'
import settings from './settings/reducers'
import user from './user/reducers'

export default history =>
  combineReducers({
    router: connectRouter(history),
    foodMenuData,
    user,
    menu,
    settings,
    notification,
    food,
    orders,
    discount,
    dashboard
  })
